import { groq } from "next-sanity"

import { AppSettings } from "@/settings"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { articleMainGroupProjection } from "../sanity/articleMainGroup.projection"

export const queryArticleMainGroup = {
  async articleMainGroup(parent, args, context, info) {
    const { id, lang = AppSettings.defaultLocale(), cdn = true } = args

    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.AHG,
      operation: Operations.READ,
    })

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })

    const draftsFilter = `&& !(_id in path("drafts.**"))`

    const articleMainGroup = await client.fetch(
      groq`*[_type=="articleMainGroup" && _id==$id ${draftsFilter}][0] {
          ...,
          ${articleMainGroupProjection()}
        }`,
      { id },
    )

    return articleMainGroup
  },
}
